
/* // In User
certification: {
	certification_id: string,
	obtained_date?: string, //local utc iso string
	expiry_date?: string,
	last_modified_date: string,
	notes: string [],
	files: {
		file: any,
		uploaded_date: string
	}[],
} [],

// In Asset
certification: {
	certification_id: string,
	obtained_datetime?: string, //local utc iso string
	expiry_date?: string,
	last_modified_date: string,
	notes: string [],
	files: {
		file: any,
		uploaded_date: string
	}[]
} [],

//asset_ids, component_ids...
 */





// For records of certificates of individuals and assets
export interface CertificationRecord
{
	_id: string,
	
	//for asset certifications
	//in case of whole leeway or org we will include all assets ?

	//components for future to have ability to refer certification by components
	asset_ids?: string[],
	system_id?: string,
	component_id?: string,
	center_id?: string,
	
	// For user certifications
	// Always refers to one user (TODO: ALWAYS & OPTIONAL?)
	user?: {
		_id: string,
		name: string,
		email: string,
	},
	
	certification_id: string,
	obtained_datetime?: string, //local utc iso string
	expiry_date?: string,
	last_modified_date?: string,
	
	notes: string [],
	
	files?: {
		file: any,
		uploaded_date: string
	}[],
			
	
	
}



// To save actual certificates
export interface Certification
{
	_id: string,
	
	certification_for: CertificationFor,

	name: string,
	
	category: string,
	type?: string,
	lead_time_in_days?: number,
	
	is_required_to_operate: boolean,
	is_physical_copy_required: boolean,
}






export enum CertificationFor
{
	USER = 'User',
	ASSET = 'Asset',
}